// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__searchLegend__XOMp3","instruction":"instruction__searchLegend__FNim7"};